import React, { useState } from 'react';
import AutomixMosaic from './AutomixMosaic';

/**
 * The picture a set wears. A set keeps its own `cover.jpg` (written from the
 * playlist's artwork when it is built, or from a file the user chose), served
 * by the local audio server; `?v=` is the file's mtime so replacing the
 * picture replaces it on screen too.
 *
 * With no cover of its own the set falls back to the mosaic of its first four
 * tracks — which is also what "Remove cover" goes back to.
 */
export const setCoverUrl = (set) => (set?.cover
    ? `http://localhost:3069/set-cover?dir=${encodeURIComponent(set.dir)}&v=${encodeURIComponent(set.coverVersion || '')}`
    : null);

const AutomixCover = ({ set, size = 56, className = '' }) => {
    const url = setCoverUrl(set);
    const [failed, setFailed] = useState(false);

    if (!url || failed) {
        return <AutomixMosaic paths={set?.artPaths} size={size} className={className} />;
    }
    return (
        <img
            className={`amx-cover${className ? ` ${className}` : ''}`}
            src={url}
            style={{ width: size, height: size }}
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setFailed(true)}
        />
    );
};

export default AutomixCover;
